"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultEnvironment = exports.getAdpConfiguration = exports.buildAdpAnalyticsPayload = exports.adpDotcomLoggerUtil = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _dhanalytics = _interopRequireDefault(require("@adsk/dh-analytics/dist/bundles/dhanalytics.core"));
var _analytics = _interopRequireDefault(require("analytics"));
var _helpers = require("./helpers");
var _environmentSupport = require("./environmentSupport");
var _loglevel = _interopRequireDefault(require("loglevel"));
var _excluded = ["analytics_id", "cu", "ev", "event", "appSettings", "userData"];
/**
 * AdpDotcomLoggerUtil.js
 *
 * This is the core plugin file that enables ADP page-based and log-based tracking for apps embedded on .COM.
 */
/* eslint-disable camelcase */
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Grabs Oxygen ID that Me Menu sets in session storage when user logs in.
 * Will require refactoring if analytics need to be captured in a context where Me Menu does not appear.
 *
 * @returns string Oxygen ID
 */
var getOxygenId = function getOxygenId() {
  var meMenuUser = (0, _helpers.getSession)('meMenuUser');
  var OxygenId = function OxygenId(meMenuUser) {
    return meMenuUser.userId;
  };
  return meMenuUser == undefined ? undefined : OxygenId(JSON.parse(meMenuUser));
};

/**
 * Grabs Analytics ID that is set in profile session.
 *
 * @returns string Analytics ID
 */
var getAnalyticsId = function getAnalyticsId() {
  var profile = (0, _helpers.getSession)('profile');
  var AnalyticsId = function AnalyticsId(profile) {
    return profile.oxygenAnalyticsId;
  };
  return profile == undefined ? undefined : AnalyticsId(JSON.parse(profile));
};

/**
 * Builds ADP analytics payload.
 *
 * Required properties are:
 *
 * e      // Event name
 * ev     // Event value
 *
 * GDPR opt in/out logic is handled by DHAnalytics, see
 * https://git.autodesk.com/dpe/dh-analytics/blob/dff960bb027fc16bfc4c4e756686196eb1456237/src/js/core/DHAnalytics.js#L121
 *
 * In the function below, the only named values are ones that may be processed in this function, otherwise all values can pass in.
 *
 * @param {object} payload (see definition in code below)
 * @return {object} properly formatted analytics payload for ADP
 * */
var buildAdpAnalyticsPayload = function buildAdpAnalyticsPayload(_ref) {
  var analytics_id = _ref.analytics_id,
    cu = _ref.cu,
    ev = _ref.ev,
    event = _ref.event,
    _ref$appSettings = _ref.appSettings,
    appSettings = _ref$appSettings === void 0 ? {} : _ref$appSettings,
    _ref$userData = _ref.userData,
    userData = _ref$userData === void 0 ? {} : _ref$userData,
    otherFields = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _userData = {
      userData: userData
    },
    _userData$userData = _userData.userData,
    _userData$userData$an = _userData$userData.analyticsId,
    analyticsId = _userData$userData$an === void 0 ? analytics_id || getAnalyticsId() : _userData$userData$an,
    _userData$userData$ox = _userData$userData.oxygenUserId,
    oxygenUserId = _userData$userData$ox === void 0 ? cu || getOxygenId() : _userData$userData$ox;

  /* The following list includes any possible properties. Any properties with undefined values get removed automatically. */
  var payload = _objectSpread({
    analytics_id: analyticsId,
    cu: oxygenUserId,
    e: event,
    ev: ev
  }, otherFields);

  /*
  IMPORTANT: On this return statement, the following step will
  1. sort the keys by alpha (for easier debugging)
  2. remove keys with [null, undefined, ''] as the value
  */
  return function (dontReturnValsArr, obj) {
    var cleanObj = {};
    Object.entries(obj).sort().forEach(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];
      if (!dontReturnValsArr.includes(val)) {
        cleanObj[key] = val;
      }
    });
    return cleanObj;
  }([null, undefined, ''], payload);
};

/**
 * Determines if we need adp stg or prod. Includes currentHostname which allows passing in custom hostname.
 *
 * @param {*} currentHostname
 * @returns string
 */
exports.buildAdpAnalyticsPayload = buildAdpAnalyticsPayload;
var setDefaultEnvironment = function setDefaultEnvironment(currentHostname) {
  return (0, _environmentSupport.isProductionHost)(currentHostname) ? _environmentSupport.adpEnvironmentOptionList.Production : _environmentSupport.adpEnvironmentOptionList.Staging;
};

/**
 * Builds environment configuration, grabbed from settings. Structure needs to be:
 *
 * adpConfig: {
 *   prd: {
 *     serviceUrl
 *     appId
 *     apiKey
 *     signWith
 *   },
 *   stg: {
 *     serviceUrl
 *     appId
 *     apiKey
 *     signWith
 *   }
 * }
 *
 * @param {Object} config
 * @returns {Object}
 */
exports.setDefaultEnvironment = setDefaultEnvironment;
var getAdpConfiguration = function getAdpConfiguration(config) {
  if ((0, _helpers.isEmpty)(config.adpConfig)) {
    _loglevel.default.warn('getAdpConfiguration() - ADP config not present');
    return false;
  }
  var adpConfig = config.adpConfig;
  var adpReturnConfig = {};

  /* If config specifies the needed env, grab that set from the adpConfig object passed in. */
  if (adpConfig.environment) {
    adpReturnConfig = adpConfig[adpConfig.environment];
    adpReturnConfig.environment = adpConfig.environment;
  } else {
    adpReturnConfig = adpConfig[setDefaultEnvironment()];
    adpReturnConfig.environment = setDefaultEnvironment();
  }
  adpReturnConfig.allowTracking = 'allowTracking' in adpConfig ? adpConfig.allowTracking : undefined;
  return adpReturnConfig;
};

/* Initializes the plugin function */
exports.getAdpConfiguration = getAdpConfiguration;
var adpDotcomLoggerUtil = function adpDotcomLoggerUtil(configuration) {
  var retval = (0, _analytics.default)({
    debug: true,
    plugins: [adpProviderPlugin(configuration)]
  });
  if (typeof window !== 'undefined') {
    window.Analytics = retval;
  }
  return retval;
};

/**
 *  This is an Autodesk Data Platform plugin.
 *
 * @param {Object} configuration
 */
exports.adpDotcomLoggerUtil = adpDotcomLoggerUtil;
var adpProviderPlugin = function adpProviderPlugin() {
  var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var namespace = 'provider-adp';
  var adpConfig = {};
  return {
    NAMESPACE: namespace,
    config: configuration,
    initialize: function initialize(payload) {
      /* Load our environmental config. */
      var _getAdpConfiguration = getAdpConfiguration(payload.config),
        appId = _getAdpConfiguration.appId,
        environment = _getAdpConfiguration.environment,
        serviceUrl = _getAdpConfiguration.serviceUrl,
        apiKey = _getAdpConfiguration.apiKey,
        signWith = _getAdpConfiguration.signWith,
        allowTracking = _getAdpConfiguration.allowTracking;
      adpConfig.appId = appId;
      adpConfig.env = environment;
      adpConfig.ADPData = {
        apiKey: apiKey,
        signWith: signWith
      };
      adpConfig.allowTracking = allowTracking;
      if (!appId || !serviceUrl || !apiKey || !signWith) {
        _loglevel.default.warn("adpDotcomLoggerUtil() - Bad configuration, turning off plug-in ".concat(namespace), payload.config);
        var analyticsInstance = payload.instance;
        analyticsInstance.plugins.disable(namespace);
      }
    },
    /**
     * Handles the event logging to ADP
     *
     * Endpoints include:
     *  - /analyticsservices/api/event/v1/app/appId/message
     *    Access using dh-analytics logger.logWithTracking
     *  - /akpeventservices/api/eventtrack/v2/app/appId/event/
     *    Access using dh-analytics logger.track
     *
     * Some custom logic for page_view as it's handled differently.
     */
    track: function track(_ref4) {
      var payload = _ref4.payload;
      // First, let's see what kind of event we're looking at here
      var eventType = 'logWithTracking';
      if (payload.properties.hasOwnProperty('apiType') && payload.properties.apiType === 'akpeventservices') {
        eventType = 'track';
      }
      payload.properties.apiType = undefined;

      // Set of consts that AdpLoggerUtil wants
      var otherParams = buildAdpAnalyticsPayload(payload.properties);
      var payloadToAdp = _objectSpread({
        e: payload.event
      }, otherParams);

      // Using static DHAnalytics as AdpLoggerUtil nor async methods support page tracking
      if (payload.event === 'page_view' && typeof window !== 'undefined' && typeof window.location !== 'undefined') {
        // Page view event value should be URL, so reset it here.
        payloadToAdp.ev = window.location.href;

        // Capture scrollParent if exists
        var scrollParent;
        if (payloadToAdp.scrollParent !== undefined) {
          scrollParent = payloadToAdp.scrollParent;
          payloadToAdp.scrollParent = undefined;
        }
        return _dhanalytics.default.plugins.pageviews.create(otherParams.ev, _objectSpread(_objectSpread({}, adpConfig), {}, {
          scrollParent: scrollParent,
          data: _objectSpread({}, payloadToAdp)
        }));
      }

      // Only accepts a subset of data */
      if (eventType === 'track') {
        return _dhanalytics.default.track(_objectSpread(_objectSpread({}, adpConfig), {}, {
          event: payload.event,
          value: payload.properties.eventValue,
          data: _objectSpread({}, payload.properties)
        }));
      }
      return _dhanalytics.default.logWithTracking(_objectSpread(_objectSpread({}, adpConfig), {}, {
        event: payload.event,
        value: otherParams.ev,
        data: _objectSpread({}, payloadToAdp)
      }));
    },
    loaded: function loaded() {
      return true;
    }
  };
};